import React, { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom"; // Import useNavigate
import Container from "../components/Container.tsx";
import Navbar from "../components/Navbar.tsx";
import Footer from "../components/Main/Footer.tsx";
import axios from "axios";
import sendEmail from "../emailutil.js";
import sendEmailToOwner from "../emailUtilOwner.js";

import { ToastContainer, toast } from "react-toastify";
import { useSelector } from "react-redux";
import NavbarMobile from "../components/NavbarMobile.tsx";

const formatAddress = (state: any, format: string | any) => {
  if (format !== "physical") {
    return `Email: ${getParam("email")}` || "N/A";
  }

  // Get address data from URL parameters
  const encodedAddressData = getParam("addressData");
  let addressData;
  try {
    addressData = JSON.parse(decodeURIComponent(encodedAddressData || "{}"));
    console.log("Parsed address data:", addressData); // Debug log
  } catch (e) {
    console.error("Error parsing address data:", e);
    // Fallback to Redux state if URL params fail
    addressData = state.address;
    console.log("Falling back to Redux state:", addressData);
  }

  const language = state.language.value;

  // Combine data sources with fallbacks
  const finalData = {
    firstName: addressData.firstName || state.address.firstName || "N/A",
    lastName: addressData.lastName || state.address.lastName || "N/A",
    email:
      getParam("email") || addressData.email || state.address.email || "N/A",
    selectedCountry:
      addressData.selectedCountry || state.address.selectedCountry || "N/A",
    city: addressData.city || state.address.city || "N/A",
    address: addressData.address || state.address.address || "N/A",
    zipCode: addressData.zipCode || state.address.zipCode || "N/A",
    appartment: addressData.appartment || state.address.appartment || "N/A",
  };

  console.log("Final address data:", finalData); // Debug log

  if (language === "RO") {
    return `
      <strong>Prenume:</strong> ${finalData.firstName}<br>
      <strong>Nume:</strong> ${finalData.lastName}<br>
      <strong>Email:</strong> ${finalData.email}<br>
      <strong>Țară:</strong> ${finalData.selectedCountry}<br>
      <strong>Oraș:</strong> ${finalData.city}<br>
      <strong>Adresă:</strong> ${finalData.address}<br>
      <strong>Cod Poștal:</strong> ${finalData.zipCode}<br>
      <strong>Apartament:</strong> ${finalData.appartment}<br>
    `;
  }

  return `
    <strong>First Name:</strong> ${finalData.firstName}<br>
    <strong>Last Name:</strong> ${finalData.lastName}<br>
    <strong>Email:</strong> ${finalData.email}<br>
    <strong>Country:</strong> ${finalData.selectedCountry}<br>
    <strong>City:</strong> ${finalData.city}<br>
    <strong>Address:</strong> ${finalData.address}<br>
    <strong>Zip Code:</strong> ${finalData.zipCode}<br>
    <strong>Apartment:</strong> ${finalData.appartment}<br>
  `;
};

const getParam = (param: string) => {
  // Debug logs
  console.log("Full URL:", window.location.href);
  console.log("Hash:", window.location.hash);

  // Get the part after #/checkout-success?
  const fullHash = window.location.hash;
  const queryString = fullHash.split("?")[1];

  console.log("Query string extracted:", queryString);

  if (!queryString) {
    console.log("No query string found");
    return null;
  }

  const searchParams = new URLSearchParams(queryString);
  const value = searchParams.get(param);

  console.log(`Parameter ${param}:`, value);
  return value;
};

const CheckoutPageSuccess = () => {
  const [isMobile, setIsMobile] = useState(window.innerWidth < 1180);
  const reduxStateLanguage = useSelector((state: any) => state.language.value);
  const navigate = useNavigate(); // Initialize useNavigate
  const [count, setCount] = useState(15);
  const accessToken = localStorage.getItem("accessToken");
  const [hasExecuted, setHasExecuted] = useState(false);
  const [hasEmailSent, setHasEmailSent] = useState(false);
  const [hasPurchaseCompleted, setHasPurchaseCompleted] = useState(false);

  // Get parameters from both query string and hash fragment
  const queryParams = new URLSearchParams(window.location.search);
  const hashString = window.location.hash.split("?")[1]; // This gets everything after the ?
  const hashParams = new URLSearchParams(hashString);

  const location = useLocation();
  const searchParams = new URLSearchParams(location.hash.split("?")[1]);

  // Combine parameters, preferring hash fragment values
  const getParam = (key: string) => {
    return hashParams.get(key) || queryParams.get(key);
  };

  const userEmail = getParam("email");
  const itemName = getParam("items");
  const total = getParam("total");
  const bookLanguage = getParam("language");
  const language = useSelector((state: any) => state.language.value);
  const format = getParam("format");
  const quantity = parseInt(getParam("quantity") || "1", 10);
  const paymentIntentId = hashParams.get("payment_intent");
  const subject = "Confirmation of purchase";
  const message = `Confirmation of purchase of item ${itemName}`;
  const reduxState = useSelector((state: any) => state);
  const [flag, setFlag] = useState(false);

  let messageTemplate =
    language === "RO"
      ? `
  Confirmare achiziție pentru articolul ${itemName}. <br> 
  <strong>Detalii livrare:</strong><br> 
  <br><br><strong>Format: </strong>${format}<br><br>
  ${formatAddress(reduxState, format)}
`
      : `
  Confirmation of purchase of item ${itemName}. <br> 
  <strong>Delivery details:</strong><br> 
    <br><br><strong>Format:</strong> ${format}<br><br>
  ${formatAddress(reduxState, format)}
`;

  const messageTemplateAudio =
    language === "RO"
      ? `
  <br>Confirmare achiziție pentru articolul ${itemName}. <br> 
  <strong>Detalii livrare:</strong><br> 
  ${formatAddress(reduxState, format)}
  <br><br><strong>Informații suplimentare pentru formatul audio:</strong><br>
  Cartea audio este disponibilă pentru descărcare sau streaming la acest link: 
<a href="${
          process.env.REACT_APP_HOST_URL
        }/admin/audio_player" target="_blank">Ascultă aici</a>
`
      : `
  <br>Confirmation of purchase of item ${itemName}. <br> 
  <strong>Delivery details:</strong><br> 
  ${formatAddress(reduxState, format)}
  <br><br><strong>Additional Information for Audio Format:</strong><br>
  The audio book is available for download or streaming on this link: 
<a href="${
          process.env.REACT_APP_HOST_URL
        }/admin/audio_player" target="_blank">Listen Here</a>
`;

  const ownerEmailTemplate =
    language === "RO"
      ? `
<div style="font-family: Arial, sans-serif; max-width: 600px; margin: 0 auto; padding: 20px; border: 1px solid #eee; border-radius: 10px;">
  <h2 style="color: #2c3e50; text-align: center; border-bottom: 2px solid #eee; padding-bottom: 10px;">Comandă Nouă Primită</h2>
  
  <div style="margin: 20px 0;">
    <h3 style="color: #34495e;">Detalii Comandă:</h3>
    <ul style="list-style: none; padding: 0;">
      <li style="margin: 10px 0;"><strong>Produs:</strong> ${decodeURIComponent(
        itemName
      )}</li>
      <li style="margin: 10px 0;"><strong>Format:</strong> ${format}</li>
      <li style="margin: 10px 0;"><strong>Cantitate:</strong> ${quantity}</li>
      <li style="margin: 10px 0;"><strong>Email Client:</strong> ${userEmail}</li>
    </ul>
  </div>

  <div style="margin: 20px 0;">
    <h3 style="color: #34495e;">Informații Livrare:</h3>
    ${formatAddress(reduxState, format)}
  </div>

  <div style="background-color: #f8f9fa; padding: 15px; border-radius: 5px; margin-top: 20px;">
    <p style="margin: 0; color: #666;">Aceasta este o notificare automată. Vă rugăm să procesați această comandă în funcție de tipul formatului.</p>
  </div>
</div>
`
      : `
<div style="font-family: Arial, sans-serif; max-width: 600px; margin: 0 auto; padding: 20px; border: 1px solid #eee; border-radius: 10px;">
  <h2 style="color: #2c3e50; text-align: center; border-bottom: 2px solid #eee; padding-bottom: 10px;">New Order Received</h2>
  
  <div style="margin: 20px 0;">
    <h3 style="color: #34495e;">Order Details:</h3>
    <ul style="list-style: none; padding: 0;">
      <li style="margin: 10px 0;"><strong>Product:</strong> ${decodeURIComponent(
        itemName
      )}</li>
      <li style="margin: 10px 0;"><strong>Format:</strong> ${format}</li>
      <li style="margin: 10px 0;"><strong>Quantity:</strong> ${quantity}</li>
      <li style="margin: 10px 0;"><strong>Customer Email:</strong> ${userEmail}</li>
    </ul>
  </div>

  <div style="margin: 20px 0;">
    <h3 style="color: #34495e;">Delivery Information:</h3>
    ${formatAddress(reduxState, format)}
  </div>

  <div style="background-color: #f8f9fa; padding: 15px; border-radius: 5px; margin-top: 20px;">
    <p style="margin: 0; color: #666;">This is an automated notification. Please process this order according to the format type.</p>
  </div>
</div>
`;

  const customerEmailTemplate =
    language === "RO"
      ? `
<div style="font-family: Arial, sans-serif; max-width: 600px; margin: 0 auto; padding: 20px; border: 1px solid #eee; border-radius: 10px;">
  <h2 style="color: #2c3e50; text-align: center; border-bottom: 2px solid #eee; padding-bottom: 10px;">Confirmare Comandă</h2>
  
  <div style="text-align: center; margin: 20px 0;">
    <p style="font-size: 16px; color: #2c3e50;">Vă mulțumim pentru achiziție!</p>
  </div>

  <div style="margin: 20px 0;">
    <h3 style="color: #34495e;">Detalii Comandă:</h3>
    <ul style="list-style: none; padding: 0;">
      <li style="margin: 10px 0;"><strong>Produs:</strong> ${decodeURIComponent(
        itemName
      )}</li>
      <li style="margin: 10px 0;"><strong>Format:</strong> ${format}</li>
      <li style="margin: 10px 0;"><strong>Cantitate:</strong> ${quantity}</li>
    </ul>
  </div>

  ${
    format === "physical"
      ? `
    <div style="margin: 20px 0;">
      <h3 style="color: #34495e;">Informații Livrare:</h3>
      ${formatAddress(reduxState, format)}
      <p style="color: #666; margin-top: 10px;">Veți fi contactat de serviciul nostru de curierat în curând.</p>
    </div>
  `
      : `
    <div style="margin: 20px 0;">
      <h3 style="color: #34495e;">Informații Acces:</h3>
      <p>Puteți accesa cartea ${
        format === "audio" ? "audio" : "în format PDF"
      } în cabinetul personal la secțiunea "Comenzi".</p>
      ${
        format === "audio"
          ? `<p>Puteți asculta cartea audio direct prin player-ul nostru sau o puteți descărca pentru ascultare offline.</p>`
          : `<p>Puteți descărca copia PDF imediat din pagina de comenzi.</p>`
      }
    </div>
  `
  }

  <div style="background-color: #f8f9fa; padding: 15px; border-radius: 5px; margin-top: 20px;">
    <p style="margin: 0; color: #666;">Dacă aveți întrebări, nu ezitați să ne contactați.</p>
  </div>

  <div style="text-align: center; margin-top: 20px; padding-top: 20px; border-top: 1px solid #eee;">
    <p style="color: #666; font-size: 12px;">Acesta este un email automat, vă rugăm să nu răspundeți direct la acest mesaj.</p>
  </div>
</div>
`
      : `
<div style="font-family: Arial, sans-serif; max-width: 600px; margin: 0 auto; padding: 20px; border: 1px solid #eee; border-radius: 10px;">
  <h2 style="color: #2c3e50; text-align: center; border-bottom: 2px solid #eee; padding-bottom: 10px;">Order Confirmation</h2>
  
  <div style="text-align: center; margin: 20px 0;">
    <p style="font-size: 16px; color: #2c3e50;">Thank you for your purchase!</p>
  </div>

  <div style="margin: 20px 0;">
    <h3 style="color: #34495e;">Order Details:</h3>
    <ul style="list-style: none; padding: 0;">
      <li style="margin: 10px 0;"><strong>Product:</strong> ${decodeURIComponent(
        itemName
      )}</li>
      <li style="margin: 10px 0;"><strong>Format:</strong> ${format}</li>
      <li style="margin: 10px 0;"><strong>Quantity:</strong> ${quantity}</li>
    </ul>
  </div>

  ${
    format === "physical"
      ? `
    <div style="margin: 20px 0;">
      <h3 style="color: #34495e;">Delivery Information:</h3>
      ${formatAddress(reduxState, format)}
      <p style="color: #666; margin-top: 10px;">You will be contacted by our courier service shortly.</p>
    </div>
  `
      : `
    <div style="margin: 20px 0;">
      <h3 style="color: #34495e;">Access Information:</h3>
      ${
        format === "pdf"
          ? `
          <p>Cartea dvs. este disponibilă în mai multe formate pentru confortul dvs.:</p>
          <ul style="list-style: none; padding-left: 0; margin-top: 10px;">
            <li style="margin: 5px 0;">📱 PDF - Perfect pentru toate dispozitivele</li>
            <li style="margin: 5px 0;">📖 EPUB - Ideal pentru cititoare electronice</li>
            <li style="margin: 5px 0;">📚 MOBI - Compatibil cu dispozitivele Kindle</li>
          </ul>
          <p style="margin-top: 10px;">Puteți descărca oricare dintre aceste formate din pagina de comenzi din cabinetul personal.</p>
          `
          : `<p>Puteți asculta cartea audio direct prin player-ul nostru sau o puteți descărca pentru ascultare offline.</p>`
      }
    </div>
  `
  }

  <div style="background-color: #f8f9fa; padding: 15px; border-radius: 5px; margin-top: 20px;">
    <p style="margin: 0; color: #666;">If you have any questions, please don't hesitate to contact us.</p>
  </div>

  <div style="text-align: center; margin-top: 20px; padding-top: 20px; border-top: 1px solid #eee;">
    <p style="color: #666; font-size: 12px;">This is an automated email, please do not reply directly to this message.</p>
  </div>
</div>
`;

  const emailData = {
    userEmail: userEmail,
    itemName: decodeURIComponent(itemName),
    subject:
      language === "RO"
        ? "Comandă Nouă Primită - Spirit Liber Book"
        : "New Order Received - Spirit Liber Book",
    message: ownerEmailTemplate,
    recepient: process.env.REACT_APP_OWNER_EMAIL,
  };

  const emailData2 = {
    userEmail: userEmail,
    itemName: decodeURIComponent(itemName),
    subject:
      language === "RO"
        ? "Confirmarea Comenzii Tale Spirit Liber Book"
        : "Your Spirit Liber Book Order Confirmation",
    message: customerEmailTemplate,
    recepient: userEmail,
  };

  useEffect(() => {
    flag && notify(true);
  }, [flag]);

  const notify = (successful: boolean) => {
    toast(
      <div
        style={{
          display: "flex",
          alignItems: "center",
          flexDirection: "column",
          width: "100%",
        }}
      >
        {successful
          ? `Payment successful, you will be redirected in ${count} seconds`
          : "Payment failed"}
      </div>,
      {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      }
    );
  };

  useEffect(() => {
    // Countdown logic
    const timer = setInterval(() => {
      setCount((prevCount) => prevCount - 1);
    }, 1000);

    // Redirect after countdown finishes
    if (count === 0) {
      navigate("/admin/orders");
    }

    // Cleanup the timer on component unmount
    return () => clearInterval(timer);
  }, [count, navigate]);

  useEffect(() => {
    const makePurchase = async () => {
      // Prevent multiple executions
      if (hasEmailSent || hasPurchaseCompleted) {
        return;
      }

      setFlag(true);

      if (!accessToken) {
        console.error("No access token found");
        notify(false);
        return;
      }

      // Get all required parameters
      const email = getParam("email");
      const items = getParam("items");

      // Check if all required values are present
      const paymentIntentId = getParam("payment_intent");

      if (!paymentIntentId || !format || !quantity || !email || !items) {
        console.error("Missing required values:", {
          paymentIntentId,
          format,
          quantity,
          email,
          items,
        });
        notify(false);
        return;
      }

      try {
        // Verify payment status first
        const paymentResponse = await axios.get(
          `${process.env.REACT_APP_SERVER_URL}/purchases/payment-intent/${paymentIntentId}`
        );

        if (paymentResponse.data.paymentIntent?.status !== "succeeded") {
          console.error("Payment not successful");
          notify(false);
          return;
        }

        console.log("Format from URL:", format);

        // Only proceed with purchase if not already completed
        if (!hasPurchaseCompleted) {
          const response = await axios.post(
            `${process.env.REACT_APP_SERVER_URL}/purchases/purchase`,
            {
              format,
              quantity: parseInt(quantity, 10),
              includeUser: format === "physical" && accessToken ? true : false,
            },
            {
              headers: {
                ...(accessToken
                  ? { Authorization: `Bearer ${accessToken}` }
                  : {}),
                "Content-Type": "application/json",
              },
            }
          );

          if (response.status === 201) {
            setHasPurchaseCompleted(true);

            // Only send emails if not already sent
            if (!hasEmailSent) {
              const emailData = {
                userEmail: email,
                itemName: decodeURIComponent(items),
                subject:
                  language === "RO"
                    ? "Comandă Nouă Primită - Spirit Liber Book "
                    : "New Order Received - Spirit Liber Book",
                message: ownerEmailTemplate,
                recepient: process.env.REACT_APP_OWNER_EMAIL,
              };

              const emailData2 = {
                userEmail: email,
                itemName: decodeURIComponent(items),
                subject:
                  language === "RO"
                    ? "Confirmarea Comenzii Tale Spirit Liber Book"
                    : "Your Spirit Liber Book Order Confirmation",
                message: customerEmailTemplate,
                recepient: email,
              };

              // Send emails
              await Promise.all([
                sendEmailToOwner(emailData),
                sendEmail(emailData2),
              ]);

              setHasEmailSent(true);
            }

            // Download if not physical format
            if (format !== "physical") {
              await downloadBook(format);
            }

            // Clear the cart after successful purchase
            localStorage.removeItem("cartItems");
            sessionStorage.removeItem("checkoutData");

            setHasExecuted(true);
          }
        }
      } catch (error) {
        console.error("Error:", error);
        notify(false);
      }
    };

    // Only run if we haven't executed yet and all required values are present
    if (!hasExecuted && !hasEmailSent && !hasPurchaseCompleted) {
      const requiredValues = {
        paymentIntentId: hashParams.get("payment_intent"),
        format: getParam("format"),
        quantity: getParam("quantity"),
        email: getParam("email"),
        items: getParam("items"),
        accessToken: localStorage.getItem("accessToken"),
      };

      console.log("Required values:", requiredValues);

      const allValuesPresent = Object.values(requiredValues).every(
        (value) => value !== null
      );

      if (allValuesPresent) {
        makePurchase();
      } else {
        console.error("Missing required values:", requiredValues);
        // notify(false);
      }
    }
  }, [hasExecuted, hasEmailSent, hasPurchaseCompleted]);

  const downloadBook = async (format: string) => {
    if (!format) {
      console.error("No format provided for download");
      return;
    }

    try {
      const response = await axios.get(
        `${process.env.REACT_APP_SERVER_URL}/purchases/download/${format}`,
        {
          headers: {
            Authorization: `Bearer ${accessToken}`,
          },
          responseType: "blob",
        }
      );

      const fileName = format === "audio" ? "sample-audio.mp3" : "sample-1.pdf";
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", fileName);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

      console.log("Download successful");
    } catch (error) {
      console.error("Error during file download:", error);
      // notify(false);
    }
  };

  useEffect(() => {
    // Check if this is a valid checkout session
    const paymentIntent = getParam("payment_intent");
    const processedPayments = JSON.parse(
      localStorage.getItem("processedPayments") || "[]"
    );

    // If no payment intent or payment was already processed, redirect to home
    if (!paymentIntent || processedPayments.includes(paymentIntent)) {
      navigate("/");
      return;
    }

    // Store the processed payment intent
    if (paymentIntent) {
      localStorage.setItem(
        "processedPayments",
        JSON.stringify([...processedPayments, paymentIntent])
      );
    }

    // Clear processed payments after 24 hours
    const clearOldPayments = () => {
      localStorage.removeItem("processedPayments");
    };
    setTimeout(clearOldPayments, 24 * 60 * 60 * 1000);

    return () => {
      // Cleanup timeout if component unmounts
      clearTimeout(clearOldPayments);
    };
  }, []);

  useEffect(() => {
    console.log("URL Parameters:", {
      email: getParam("email"),
      addressData: getParam("addressData"),
      format: getParam("format"),
    });

    console.log("Redux State:", reduxState);

    // Check backup data in sessionStorage
    const backupData = sessionStorage.getItem("checkoutFormData");
    if (backupData) {
      console.log("Backup Form Data:", JSON.parse(backupData));
    }
  }, []);

  // Also let's log the other parameter getters you have:

  return (
    <Container>
      {isMobile ? (
        <NavbarMobile lang={reduxStateLanguage} />
      ) : (
        <Navbar lang={reduxStateLanguage} />
      )}
      <div style={{ textAlign: "center" }}>
        <ToastContainer />
        <h1>
          {language === "EN" && "Checkout Success"}
          {language === "RO" && "Achiziționare cu succes"}
        </h1>

        <div
          style={{
            display: "flex",
            flexDirection: "column",
            border: "1px solid rgba(255, 255, 255, 0.2)",
            borderRadius: "32px",
            width: "fit-content",
            margin: "auto",
            padding: "20px",
            boxShadow: "0px 6px 15px rgba(0, 0, 0, 0.2)",
            background: "rgba(255, 255, 255, 0.1)",
            backdropFilter: "blur(10px)",
            WebkitBackdropFilter: "blur(10px)",
          }}
        >
          {format === "physical" && (
            <h2>
              {language === "EN" && (
                <>
                  <p>The book has been successfully purchased.</p>
                  <p>You will be contacted by a courier shortly.</p>
                </>
              )}
              {language === "RO" && (
                <>
                  <p>Cumpărătură efectuată cu succes.</p>
                  <p>Veți fi contactat de un curier în scurt timp.</p>
                </>
              )}
            </h2>
          )}

          {format === "audio" && (
            <h2>
              {language === "EN" && (
                <>
                  <p>The audiobook has been successfully purchased!</p>
                  <p>To listen to your audiobook:</p>
                  <p>1. Go to your account menu</p>
                  <p>2. Select "Audio Player"</p>
                  <p>3. Enjoy your audiobook!</p>
                </>
              )}
              {language === "RO" && (
                <>
                  <p>Cartea audio a fost cumpărată cu succes!</p>
                  <p>Pentru a asculta cartea audio:</p>
                  <p>1. Accesați meniul contului dvs.</p>
                  <p>2. Selectați "Audio Player"</p>
                  <p>3. Ascultați cartea audio!</p>
                </>
              )}
            </h2>
          )}
          {format === "pdf" && (
            <h2>
              {language === "EN" && (
                <>
                  <p>The audiobook has been successfully purchased!</p>
                  <p>The book will download automatically.</p>
                  <p>You can also download it from your account menu.</p>
                </>
              )}
              {language === "RO" && (
                <>
                  <p>Cartea audio a fost cumpărată cu succes!</p>
                  <p>Cartea va fi descărcată automat.</p>
                  <p>
                    De asemenea, poate fi descărcată din meniul contului dvs.
                  </p>
                </>
              )}
            </h2>
          )}
        </div>

        <p>
          {language === "EN" &&
            `Redirecting to home page in ${count} seconds...`}
          {language === "RO" &&
            `Redirecționare către pagina principală în ${count} secunde...`}
        </p>
      </div>
      <Footer />
    </Container>
  );
};

export default CheckoutPageSuccess;
